import React, { ReactNode } from 'react';
import Text from '../Text/Text';
import Wrapper from '../Wrapper';
import { TextColorTypes } from '../../types';
import './VideoCard.less';

type textSizeType = 1 | 2 | 3 | 4;

type positionYType = 'center';

export type VideoCardType = {
  videoHintTitle: string | ReactNode;
  titleFontWeight?: 'bold' | 'semiBold';
  active?: boolean;
  hover?: boolean;
  background?:
    | 'strong'
    | 'soft'
    | 'primary'
    | 'indicator'
    | 'active'
    | 'white'
    | 'gray-indicator'
    | 'soft-white'
    | 'primary-light';
  titleColor?: TextColorTypes;
  titleSize?: textSizeType;
  iconPositionY?: positionYType;
  disabled?: boolean;
  onItemClick?: React.MouseEventHandler<HTMLDivElement>;
  actions?: ReactNode | any;
  padding?: 'xs' | 'sm' | 'md';
  borderRadius?: 'sm' | 'md' | 'lg' | 'xl';
};
const VideoCard: React.FC<VideoCardType> = ({
  videoHintTitle,
  titleFontWeight,
  actions,
  onItemClick,
  active,
  background,
  titleColor,
  titleSize = 2,
  iconPositionY,
  padding = 'md',
  disabled = false,
  hover = false,
  borderRadius = 'lg',
}) => {
  const classNames: String[] = ['video-card-container'];
  classNames.push(
    `video-card-container-border-${borderRadius}`,
    `video-card-container-padding-${padding}`,
  );
  if (active) {
    classNames.push('video-card-container-active');
  }
  if (background) {
    classNames.push(`video-card-container-${background}`);
  }
  if (hover) {
    classNames.push(`video-card-container-hover`);
  }
  if (disabled) {
    classNames.push(`video-card-container-disabled`);
  }
  const titleFontWeightProps: any = {};
  if (titleFontWeight === 'bold') {
    titleFontWeightProps.bold = true;
  }
  if (titleFontWeight === 'semiBold') {
    titleFontWeightProps.semiBold = true;
  }
  return (
    <div className={classNames.join(' ')} onClick={onItemClick}>
      <Wrapper display="flex" justifyContent="space-between">
        <Wrapper display="flex" alignItems={iconPositionY}>
          {actions && <div className="actions-wrapper">{actions}</div>}

          {videoHintTitle && (
            <Wrapper display="flex" flexDirecton="column" pl={2}>
              <Text
                semiBold
                level={titleSize}
                rows={1}
                {...titleFontWeightProps}
                textColor={titleColor}
                title={String(videoHintTitle)}
              >
                {videoHintTitle}
              </Text>
            </Wrapper>
          )}
        </Wrapper>
      </Wrapper>
    </div>
  );
};

export default VideoCard;
